import { Injectable } from '@angular/core';
import { Either, Left, Right } from 'purify-ts';
import { Paginated } from '../../domain/conversations/types';
import { TemplatesRepositoryFailure } from '../../domain/templates/failure';
import { ITemplatesRepository } from '../../domain/templates/i-templates-repository';
import {
  CreateTemplateProps,
  CreatedTemplate,
  DeleteTemplateProps,
  ListTemplatesOptions,
  Template,
} from '../../domain/templates/types';
import { fakeTemplates } from './data';

/** As roles do usuário fake — a API vincula o template a todas as roles do token. */
const FAKE_OWNER_ROLES = ['TD', 'RS'];

@Injectable({
  providedIn: 'root',
})
export class FakeTemplatesRepository implements ITemplatesRepository {
  private templates: Template[] = fakeTemplates.map(template => ({ ...template }));

  public async getList(
    options: ListTemplatesOptions
  ): Promise<Either<TemplatesRepositoryFailure, Paginated<Template>>> {
    const filtered = options.status
      ? this.templates.filter(template => template.status === options.status)
      : [...this.templates];

    const offset = Number(options.cursor ?? 0);
    const limit = options.limit && options.limit > 0 ? options.limit : filtered.length;
    const items = filtered.slice(offset, offset + limit);
    const next = offset + items.length;

    return Right({ items, nextCursor: next < filtered.length ? String(next) : null });
  }

  public async create(
    props: CreateTemplateProps
  ): Promise<Either<TemplatesRepositoryFailure, CreatedTemplate>> {
    if (this.templates.some(template => template.name === props.name)) {
      return Left(TemplatesRepositoryFailure.duplicatedName());
    }

    const created: Template = {
      id: `t${this.templates.length + 1}-${Date.now()}`,
      name: props.name,
      language: props.language,
      category: props.category,
      status: 'PENDING',
      components: props.components,
      ownerRoles: [...FAKE_OWNER_ROLES],
    };

    this.templates = [created, ...this.templates];

    return Right({
      id: created.id,
      name: created.name,
      language: created.language,
      status: created.status,
      ownerRoles: created.ownerRoles,
    });
  }

  public async remove(
    props: DeleteTemplateProps
  ): Promise<Either<TemplatesRepositoryFailure, void>> {
    this.templates = this.templates.filter(template => template.name !== props.name);
    return Right(undefined);
  }
}
